export default __webpack_public_path__ + "static/media/i_bus-tro_pp_tagless.3f766fda.svg";